<template>
  <div class="section">
    <div class="box">
      <div class="section">
        <b-field label="Name:" horizontal
          ><b-input v-model.lazy="name"></b-input>
          <b-select v-model="match">
            <option v-for="matchType in matchTypes" :value="matchType" :key="matchType">
              {{ matchType }}
            </option>
          </b-select>
          <b-button type="is-success" @click="AddName()">Add</b-button>
        </b-field>
      </div>
      <div>
        <b-table :data="names" paginated :per-page="this.perPage" :current-page.sync="this.page" backend-pagination :total="this.total" @page-change="onPageChange" :loading="this.loading">
          <b-table-column v-slot="props" label="Name" backend-pagination backend-sorting>
            {{ props.row.name }}
          </b-table-column>
          <b-table-column v-slot="props" label="Is First Name?">
            <b-checkbox v-model="props.row.isFirstName" :true-value="1" :false-value="0"></b-checkbox>
          </b-table-column>
          <b-table-column v-slot="props">
            <b-button type="is-danger" @click="DeleteName(props.row.id)">Delete</b-button>
          </b-table-column>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");

export default {
  components: {},
  data: function () {
    return {
      names: [],
      newApiUrl: "https://api.jeak.co.uk",
      nameInput: "",
      perPage: 50,
      page: 1,
      total: 0,
      loading: true,
      match: "exact",
      matchTypes: ["exact", "like"],
    };
  },
  methods: {
    GetNames: async function () {
      this.loading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      this.GetNameCount();
      const response = await axios.get(this.newApiUrl + `/names?page=${this.page}&perpage=${this.perPage}&filter=${this.name}&match=${this.match}`, config);
      this.names = response.data;
      this.loading = false;
    },
    GetNameCount: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      const response = await axios.get(this.newApiUrl + `/names/count?filter=${this.name}&match=${this.match}`, config);
      this.total = response.data.count;
    },
    DeleteName: async function (nameId) {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      const response = await axios.delete(this.newApiUrl + `/names/${nameId}`, config);
      this.GetNames();
    },
    onPageChange: function (page) {
      this.page = page;
      this.GetNames();
    },
    FilterNames: async function () {
      this.GetNames();
    },
    AddName: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      const body = {
        name: this.name,
      };
      const response = await axios.post(`${this.newApiUrl}/names`, body, config);
      this.GetNames();
    },
  },
  computed: {
    name: {
      get() {
        return this.nameInput;
      },
      set(val) {
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.nameInput = val;
          this.GetNames();
        }, 500);
      },
    },
  },
  mounted() {
    this.GetNames();
  },
};
</script>

<style scoped></style>
